export default {
  lastMedia: (state) => {
    return state.lastMedia;
  },
  videoLastMedia: (state) => {
    return state.videoLastMedia;
  },
  audioLastMedia: (state) => {
    return state.audioLastMedia;
  },
  picLastMedia: (state) => {
    return state.picLastMedia;
  },

  chooseMedia: (state) => {
    return state.chooseMedia;
  },

  moreMedia: (state) => {
    return state.moreMedia;
  },

  tabItems: (state) => {
    return state.tabItems;
  },
  tabItemsOpetions: (state) => {
    const tabItemsOpetions = [];
    state.tabItems.forEach(func);
    function func(item) {
      const pushItem = {
        id: item.id,
        label: item.title,
      };
      tabItemsOpetions.push(pushItem);
    }
    return tabItemsOpetions;
  },

  moreViewMedia: (state) => {
    return state.moreViewMedia;
  },

  similarMedia: (state) => {
    return state.similarMedia;
  },

  oneMedia: (state) => {
    return state.oneMedia;
  },

  comments: (state) => {
    return state.comments;
  },
  commentsTotal: (state) => {
    return state.commentsTotal;
  },

  likes: (state) => {
    return state.likes;
  },

  report: (state) => {
    return state.report;
  },

  audioBannerRight: (state) => {
    return state.audioBannerRight;
  },
  audioBannerLeft: (state) => {
    return state.audioBannerLeft;
  },

  // Static Getters ---------------------------------------------------------------
};
